import {useJbHttpCrudService} from "../../core/service/jb-http-crud.service";
import {FinanceItemEntity} from "../entity/finance-item.entity";

export function useFinanceItemRepository() {
  const crud = useJbHttpCrudService<FinanceItemEntity>('finance-item')
  
  return {
    ...crud
  }
}